import React, {useState, useEffect} from 'react';
import {connect, useDispatch} from 'react-redux';
import {
    Switch,
    Route,
    Redirect,
    useLocation,
    BrowserRouter
} from 'react-router-dom';
import Header from './components/Header/Header';
import './assets/style.scss';
import EventView from './components/Event/EventView';
import FrontView from './components/FrontView';
import PlaceView from './components/Place/PlaceView';
import {getBanners, actionProfile, toggleMenu} from './redux/actions';
// @ts-ignore
import Analytics from 'react-router-ga';
import 'bootstrap/dist/css/bootstrap.min.css';
import Page from './components/Page/Page';
import {GA_ID} from './constants';
import LoginFacebook from './components/TestFacebook';
import {getEmptyFilters} from './helpers/utils';

const apiUrl = process.env.REACT_APP_API_URL;

const getWidth = () => window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;

function App(props: any) {
    const [rootClass, setRootClass] = useState('root');
    const [currentWidth, setCurrentWidth] = useState(getWidth());
    const width = getWidth();
    const dispatch = useDispatch();
    const {banners, isLoggedIn} = props;

    let loggedIn = false;
    if (isLoggedIn && isLoggedIn.loggedIn) {
        loggedIn = true;
    }

    useEffect(() => {
        if (width !== currentWidth) {
            setRootClass(`root width_${width}`)
        }

    }, [width])

    useEffect(() => {

        if (!banners || typeof banners.total === 'undefined') {
            dispatch(getBanners())
        }
    }, [banners])

    useEffect(() => {
        //let cookie = document.cookie;
        dispatch(actionProfile());
        const clickHandler = (state?: any) => {
            dispatch(toggleMenu(state))
        }

        const listener = (e: MouseEvent) => {
            if (e.target && (e.target as HTMLElement).id) {
                if ((e.target as HTMLElement).id.indexOf('hamburger') > -1) {
                    clickHandler();
                } else {
                    clickHandler(false);
                }
            } else {
                clickHandler(false);
            }
        }

        window.addEventListener('click', listener)

        function updateWidth() {
            setCurrentWidth(window.innerWidth);
        }

        window.addEventListener('resize', updateWidth);
        updateWidth();
        return () => {
            window.removeEventListener('resize', updateWidth)
            window.removeEventListener('click', listener)
        };
    }, [])

    const checkSearchParam = (loc: any) => {
        const {search} = loc
        if (search) {
            if (search.startsWith('?trans') || search.startsWith('?setlang')) {
                window.location.href = `${apiUrl}/${search}`
            }
        }
        return true
    }

    const RootRedirector = (props: { from?: string | null }) => {
        const loc = useLocation()
        checkSearchParam(loc)
        if (loc.hash && loc.hash.startsWith('#/page')) {
            let newPath = loc.hash.replace('#', '');
            return <Redirect
                to={{
                    pathname: `${newPath}`
                }}
            />
        } else {
            return <Redirect
                to={{
                    pathname: `/events`
                }}
            />
        }
    }

    return (
        <BrowserRouter>
            <div className={rootClass}>
                <Header />
                <Analytics id={GA_ID} debug>
                    <Switch>
                        <Route exact path='/'>
                            <RootRedirector from='/ root'/>
                        </Route>
                        <Route exact path='/events'>
                            <FrontView filters={getEmptyFilters()} banners={null} from="/events"/>
                        </Route>
                        <Route path='/events/:filter1?/:filter2?/:filter3?/:filter4?'>
                            <FrontView filters={props.filters} banners={null} from="/events/filtered"/>

                        </Route>
                        <Route path='/event/:alias'>
                            <EventView/>
                        </Route>
                        <Route path={`/reset/:token`}>
                            <FrontView filters={getEmptyFilters()} banners={null}/>
                        </Route>
                        <Route path={`/places/:place`}>
                            <PlaceView/>
                        </Route>
                        <Route path={`/page/:page`}>
                            <Page/>
                        </Route>
                        <Route path='/#/page/:page'>
                            <Page/>
                        </Route>
                        <Route path="/fblogin">
                            <LoginFacebook/>
                        </Route>
                        <Route path="*">
                            <RootRedirector from='*'/>
                        </Route>
                    </Switch>
                </Analytics>
            </div>
        </BrowserRouter>
    );
}

const mapStateToProps = (state: any) => {
    return state;
};

export default connect(mapStateToProps, {getBanners, actionProfile})(App);
